import { Form } from 'antd';
import {
  Button,
  Col,
  Colors,
  IcPlus,
  InputSearch,
  Row,
  Select,
  Text,
} from 'basic-ui-lib';
import { debounce } from 'lodash';
import { StatusOptions } from 'modules/dashboard/services/constants';
import useGetScreensInStore from 'modules/store/services/hooks/useListScreensInStore';
import { useMemo } from 'react';
import styled from 'styled-components';

interface ScreenHeaderProps {
  onNewScreen: () => void;
  id: string;
}

type FormValues = {
  keySearch: string;
  status: string;
};

const ScreenHeader = ({ onNewScreen, id }: ScreenHeaderProps) => {
  const [form] = Form.useForm<FormValues>();
  const { mutate } = useGetScreensInStore(id, true);

  const onFinish = (values: FormValues) => {
    mutate({
      keySearch: values.keySearch || '',
      status: values.status || '',
      page: 1,
      size: 10,
    });
  };

  const debouncedSearch = useMemo(
    () =>
      debounce(() => {
        form.submit();
      }, 500),
    [form],
  );

  return (
    <Container>
      <Col gap={2}>
        <Text title_h5 semibold left>
          Screen
        </Text>
        <Text body_1 medium left color='neutral.text.3'>
          Manage displays connected to this store
        </Text>
      </Col>
      <Row flex={1} gap={16} alignItems='center' justifyContent='flex-end'>
        <Form
          form={form}
          layout='vertical'
          className='form-container'
          onFinish={onFinish}
        >
          <Form.Item name='keySearch' noStyle>
            <InputSearch
              placeholder='Search screens by name, location,...'
              onChange={debouncedSearch}
            />
          </Form.Item>

          <Form.Item name='status' noStyle>
            <Select
              options={StatusOptions}
              onChange={() => form.submit()}
              placeholder='Select Status'
              className='custom-select'
            />
          </Form.Item>
        </Form>
        <Button
          lg
          type_second
          prefix={<IcPlus width={20} height={20} fill={Colors.neutral.bg[1]} />}
          onClick={onNewScreen}
          className='add-screen-button'
        >
          New Screen
        </Button>
      </Row>
    </Container>
  );
};

export default ScreenHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 16px;

  .form-container {
    width: 60%;
    display: flex;
    gap: 16px;
  }

  .custom-select .ant-select-selector {
    width: 180px;
  }
`;
